export default __webpack_public_path__ + "static/media/bannerVideo.abde69ff.mp4";